// Liga/desliga áreas do app. Para abrir o cassino, mude para true aqui e CASSINO_ENABLED=true no .env da API.
export const CASSINO_ENABLED = false
// Adivinhe a escalação (temporário): some do menu e da home com false
export const ESCALACAO_ENABLED = true
// Doação entre jogadores: com false o formulário fica bloqueado (API: DONATIONS_ENABLED no .env)
export const DOACOES_ENABLED = false
